import InlineCommentButtonView from 'backbone/story/views/comments/inline_comment_button_view.js'
import AnnotationComments from '@contently/videojs-annotation-comments'
import InlineCommentUtils from 'utils/story/inline_comment_utils.js'
import videojs from 'video.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class VideoCommentView extends Backbone.View
  events:
    "click .js-toggle-comment-visibility"   : "toggleAnnotationMode"
    "click .dropdown-container"             : "exitActiveModes"

  initialize: (options) ->
    @permittedToComment = window.story.permitted_to_comment || false
    @options = options
    @asset = @options.asset
    @player = @options.player
    @videoElId = @options.videoElId
    @inlineCommentUtils = new InlineCommentUtils()
    @dispatcher = BackboneDispatcher.get_instance()
    @_setupCommentCollectionAndListeners()
    @commentViewMediator = page.get("commentViewMediator")
    @commentViewMediator.registerView(this)
    @_initAnnotationComments()

  toggleAnnotationMode: =>
    if @annotationComments?
      @annotationComments.fire("toggleAnnotationMode")

  exitActiveModes: ->
    @_closeActive()
    @commentCollection.removeActive()
    @commentViewMediator.removeCommentView()
    @commentViewMediator.removeCommentForm()

  remove: (removeEl = true) ->
    @annotationComments = @annotationComments.dispose()
    @commentViewMediator.unregisterView(this)
    @_teardownDispatcher()
    @undelegateEvents()
    @$commentButton.remove()
    @stopListening()
    @$el.remove() if removeEl

  topOffset: (comment) ->
    try
      if comment && comment.get("shape")
        @$el.find('.vac-shape').offset().top - $(".js-comment-placeholder").offset().top
      else
        button = @$el.find(".inline-comment-button-wrapper")
        button.offset().top - $(".js-comment-placeholder").offset().top + 40
    catch
      0

  showCommentButton: ->
    @$commentButton = new InlineCommentButtonView()
      .render()
      .$el

    @$el.find(".actions").prepend @$commentButton

    @$commentButton.on("mouseup", @commentButtonClick)
    @$commentButton.on("click", (e) -> e.stopPropagation())

  commentButtonClick: =>
    return if @commentViewMediator.commentInProgress()
    @commentCollection.removeActive()
    @commentViewMediator.removeCommentForm()
    @annotationComments.fire("addingAnnotation")

    @$el.addClass("active-new-comment")
    @$el.find(".dropdown-container").removeClass("active")

  setCommentsAreHidden: (areHidden) =>
    if areHidden
      @$el.addClass('hide-video-comments')
    else
      @$el.removeClass('hide-video-comments')

  ### MEDIATOR CALLBACKS ###

  onViewOpen: (comment) ->
    @_openAnnotation(comment)
    @$el.find(".dropdown-container").removeClass("active")

  onViewClose: () ->
    @_closeActive()

  onCommentFormClose: () ->
    @_closeActive()

  openCommentView: (comment) ->
    @_openAnnotation(comment)

  commentInView: (comment) ->
    comment.belongsToAsset(@asset)

  _initAnnotationComments: () =>
    return unless @player
    annotations = @commentCollection.forVideoPlayer(@asset)

    unless videojs.getPlugins().annotationComments
      videojs.registerPlugin('annotationComments', AnnotationComments(videojs))

    @annotationComments = @player.annotationComments(
      annotationsObjects:         annotations
      bindArrowKeys:              false
      showControls:               false
      showCommentList:            false
      showMarkerShapeAndTooltips: false
      showFullScreen:             false
      internalCommenting:         false,
      startInAnnotationMode:      true
    )

    @annotationComments.onReady(
      (() =>
        @_bindAnnotationCommentsListeners()
        @_bindDispatcher()
        @showCommentButton() if @permittedToComment
      )
    )

  _closeActive: =>
    @annotationComments.fire("closeActiveAnnotation")
    @annotationComments.fire("cancelAddingAnnotation")

    @$el.removeClass("active-new-comment")

  _setupCommentCollectionAndListeners: ->
    @commentCollection = page.get("storyComments")
    @listenTo(@commentCollection, "change:resolved", @_onInlineCommentResolved)
    @listenTo(@commentCollection, "add", @_onInlineCommentCreated)

  _onInlineCommentResolved: (comment, event) =>
    if comment.isVideo() && comment.belongsToAsset(@asset)
      @annotationComments.fire("destroyAnnotation", comment.toVideoAnnotation())

  _onInlineCommentCreated: (comment, event) =>
    if comment.isVideo() && comment.belongsToAsset(@asset)
      @commentViewMediator.removeCommentForm()
      @annotationComments.fire("newAnnotation", comment.toVideoAnnotation())

  _openAnnotation: (comment, event) =>
    return if @commentViewMediator.view == this
    $.when(
      @$el.find(".collapsible-container").addClass("active")
    ).done(() =>
      @annotationComments.fire("openAnnotation", comment.toVideoAnnotation())
    )

  showComment: (comment) ->
    @commentViewMediator.showInlineComment
      view: this
      comment: comment
      offset: @topOffset(comment)

  _bindAnnotationCommentsListeners: () ->
    # Draw video comment UI when an annotation is opened within the player
    @annotationComments.registerListener("annotationOpened", (event) =>
      return if event.detail.triggered_by_timeline
      commentModel = @commentCollection.get(event.detail.annotation.id)
      @showComment(commentModel)
    )

    # Remove video comment UI when an annotation is closed (scrubber moves outside of currently open one)
    @annotationComments.registerListener("annotationClosed", (event) =>
      comment = @commentCollection.find((comment) -> comment.get("id") == event.detail.id)
      @commentViewMediator.removeCommentView() unless comment.isResolved()
    )

    # Entered annotation mode
    @annotationComments.registerListener("annotationModeEnabled", (_event) =>
      @setCommentsAreHidden(false)
    )

    # Exited annotation mode
    @annotationComments.registerListener("annotationModeDisabled", (_event) =>
      @annotationComments.fire("cancelAddingAnnotation")
      @setCommentsAreHidden(true)
    )

    # Entered adding comment state within the player
    @annotationComments.registerListener("enteredAddingAnnotation", (event) =>
      @commentViewMediator.renderCommentForm
        view: this
        offset: @topOffset(null)
        startTime: event.detail.range.start
        video: true
        assetId: @asset.get("asset_id")
    )

    # Update and re-render comment list view with new range and shape data
    @annotationComments.registerListener("addingAnnotationDataChanged", (event) =>
      if event.detail.range
        @commentViewMediator.commentFormView.options.startTime = event.detail.range.start
        @commentViewMediator.commentFormView.options.endTime = event.detail.range.end
      else if event.detail.shape
        @commentViewMediator.commentFormView.options.shape = event.detail.shape
    )

  _bindDispatcher: () ->
    @dispatcher.on("playingVideo", @_pauseOtherVideos)

  _teardownDispatcher: () ->
    @dispatcher
      .off("playingVideo", @_pauseOtherVideos)

  ### DISPATCHER CALLBACKS ###

  _pauseOtherVideos: (playerId, event) =>
    return if playerId == @player.id()
    @pausePlayer()



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/video_comment_view.js.coffee